import { atom } from "recoil";
import { permissionObject } from "../models/Types";
import { Company } from "../../modules/Authentication/Authentication.constants";

export interface UserProfileProps {
  id: number;
  email: string;
  fullname: string;
  username: string;
  date_of_start: string;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  can_follow: boolean;
}

export interface isLoggedInSelectorProps {
  isLoggedIn: boolean;
  profile?: UserProfileProps;
  company?: Company;
}

export interface permissionProps {
  [key: string]: boolean;
}

export const isLoggedInSelector = atom<isLoggedInSelectorProps>({
  key: "isLoggedInSelector",
  default: { isLoggedIn: false, profile: undefined, company: undefined },
});

export const permissionsSelector = atom<permissionProps>({
  key: "permissionsSelector",
  default: permissionObject,
});
